<template>
  <div class="card-content-container">
    <div
      class="section section-header section-space-bottom--half"
    >
      <span
        class="pointer-on-hover text-small source-url text-ellipsis"
        @click.exact.stop="onRedirectionToSourceDocument"
        @click.middle.stop="onRedirectionToSourceDocument"
      >
        {{ sourceUrl }}
      </span>
      <span v-if="documentDetails.datePublished" class="publish-date text-small">
        {{ $t('components.cards.horizontal.publishedDate', { datePublished }) }}
      </span>
    </div>
    <div
      class="analysis-link-container"
    >
      <v-tooltip
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <div
            class="section section-title section-space-bottom--half pointer-on-hover text-big text-ellipsis--2"
            @click.middle="onRedirectionToAnalysis"
            @click.exact="onRedirectionToAnalysis"
            v-bind="attrs"
            v-on="on"
          >
            {{ documentDetails.title }}
          </div>
        </template>
        <span>
          {{ documentDetails.title }}
        </span>
      </v-tooltip>
      <div
        v-if="showDescription"
        class="text-medium section section-excerpt section-space-bottom section-space-top--half text-ellipsis--4"
      >
        {{ documentDetails.excerpt }}
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  name: 'CardContentSmallSize',
  props: {
    documentDetails: {
      type: Object,
      required: true,
    },
    showDescription: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    sourceUrl() {
      let foundSourceUrl;
      try {
        foundSourceUrl = (new URL(this.documentDetails.url)).hostname;
      } catch {
        foundSourceUrl = this.documentDetails.url;
      }

      return foundSourceUrl;
    },
    datePublished() {
      const { datePublished } = this.documentDetails;
      const format = 'LLL';
      if (typeof datePublished === 'string') {
        return moment.utc(this.documentDetails.datePublished).format(format);
      }

      return moment.utc(datePublished.seconds * 1000).format(format);
    },
  },
  methods: {
    onRedirectionToAnalysis() {
      this.$emit('onRedirectionToAnalysis');
    },
    onRedirectionToSourceDocument() {
      this.$emit('onRedirectionToSourceDocument');
    },
  },
};
</script>
<style scoped>
.card-content-container {
  text-align: left;
  padding-top: 16px;
}
.publish-date {
  white-space: nowrap;
}
.source-url {
  padding-right: 8px;
}
.source-url:hover {
  text-decoration: underline;
}
.pointer-on-hover:hover {
  cursor: pointer;
}
.analysis-link-container {
  text-decoration: none;
  color: black;
}
.text-ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.text-ellipsis--2 {
  text-overflow:ellipsis;
  overflow:hidden;
  display: -webkit-box !important;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
}
.text-ellipsis--3 {
  text-overflow:ellipsis;
  overflow:hidden;
  display: -webkit-box !important;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  white-space: normal;
}
.text-ellipsis--4 {
  text-overflow:ellipsis;
  overflow:hidden;
  display: -webkit-box !important;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  white-space: normal;
}
.section {
  margin-left: 32px;
  margin-right: 32px;
}
.section-space-bottom {
  margin-bottom: 8px;
}
.section-space-bottom--half {
  margin-bottom: 4px;
}
.section-space-top--half {
  margin-top: 4px;
}
.section-header {
  display: flex;
  justify-content: space-between;
}
.text-small {
  font-size: 8px;
  font-weight: 300;
  color: rgb(60, 60, 60);
}
.text-medium {
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  color: rgb(60, 60, 60);
}
.text-big {
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  height: 40px;
  color: #364BC9;
}
</style>
